import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ReportCover from "@/components/marketing/ReportCover";

export default function BenchmarkBanner() {
  return (
    <section data-testid="benchmark-banner">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
        <Link to="/benchmark-report" className="group block" data-testid="benchmark-banner-link">
          <div className="relative overflow-hidden rounded-2xl bg-[#0B1220] px-6 sm:px-8 py-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 transition-all duration-300 hover:shadow-[0_18px_48px_-16px_rgba(11,18,32,0.55)] hover:-translate-y-0.5">
            <div
              className="absolute inset-0 opacity-[0.12]"
              style={{ backgroundImage: "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.5) 1px, transparent 0)", backgroundSize: "22px 22px" }}
            />
            <span className="relative shrink-0">
              <ReportCover scale={0.6} tilt={-2} testId="benchmark-banner-cover" />
            </span>
            <div className="relative flex-1 min-w-0">
              <div className="text-[10.5px] uppercase tracking-[0.2em] font-semibold text-[#60A5FA]">Free report · 2026 Edition</div>
              <div className="mt-1 text-[16px] sm:text-[17px] font-semibold text-white tracking-tight">
                The UK Financial Services CPL Benchmark Report
              </div>
              <div className="mt-0.5 text-[13px] text-slate-400">
                Sector CPLs, close-rate ranges and implied acquisition costs — a 5-page PDF, no sales call.
              </div>
            </div>
            <span className="relative inline-flex items-center gap-1.5 self-start sm:self-center rounded-full bg-white text-slate-900 text-[13px] font-semibold px-5 h-10 leading-10 whitespace-nowrap group-hover:bg-slate-100 transition-colors">
              Get the report <ArrowRight className="size-3.5 transition-transform group-hover:translate-x-0.5" />
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
}
